import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCurrentLineId = createSelector(
  (state: Store) => state.dealManagement.commonDeal.currentLine.lineId,
  (currentLineId) => currentLineId,
);
